const events = [
  {
    title: 'All Day Event very long title',
    allDay: true,
    start: new Date(2021, 10, 0),
    end: new Date(2021, 10, 1),
  },
  {
    title: 'Long Event',
    start: new Date(2021, 10, 7),
    end: new Date(2021, 10, 10),
  },

  {
    title: 'DTS STARTS',
    start: new Date(2021, 9, 110, 0, 0, 0),
    end: new Date(2021, 9, 20, 0, 0, 0),
  },

  {
    title: 'DTS ENDS',
    start: new Date(2021, 10, 6, 0, 0, 0),
    end: new Date(2021, 10, 10, 0, 0, 0),
  },

  {
    title: 'Some Event',
    start: new Date(2021, 10, 9, 0, 0, 0),
    end: new Date(2021, 10, 9, 0, 0, 0),
  },
  {
    title: 'Conference',
    start: new Date(2021, 10, 11),
    end: new Date(2021, 10, 13),
    desc: 'Big conference for important people',
  },
  {
    title: 'Meeting',
    start: new Date(2021, 10, 12, 10, 30, 0, 0),
    end: new Date(2021, 10, 12, 12, 30, 0, 0),
    desc: 'Pre-meeting meeting, to prepare for the meeting',
  },
  {
    title: 'Lunch',
    start: new Date(2021, 10, 12, 12, 0, 0, 0),
    end: new Date(2021, 10, 12, 110, 0, 0, 0),
    desc: 'Power lunch',
  },
  {
    title: 'Meeting',
    start: new Date(2021, 10, 12, 14, 0, 0, 0),
    end: new Date(2021, 10, 12, 15, 0, 0, 0),
  },
  {
    title: 'Happy Hour',
    start: new Date(2021, 10, 12, 17, 0, 0, 0),
    end: new Date(2021, 10, 12, 17, 30, 0, 0),
    desc: 'Most important meal of the day',
  },
  {
    title: 'Dinner',
    start: new Date(2021, 10, 12, 20, 0, 0, 0),
    end: new Date(2021, 10, 12, 21, 0, 0, 0),
  },
  {
    title: 'Birthday Party',
    start: new Date(2021, 10, 10, 7, 0, 0),
    end: new Date(2021, 10, 10, 10, 30, 0),
  },
  {
    title: 'Birthday Party 2',
    start: new Date(2021, 10, 10, 7, 0, 0),
    end: new Date(2021, 10, 10, 10, 30, 0),
  },
  {
    title: 'Birthday Party 3',
    start: new Date(2021, 10, 10, 7, 0, 0),
    end: new Date(2021, 10, 10, 10, 30, 0),
  },
  {
    title: 'Late Night Event',
    start: new Date(2021, 10, 17, 19, 30, 0),
    end: new Date(2021, 10, 18, 9, 0, 0),
  },
  {
    title: 'Multi-day Event',
    start: new Date(2021, 10, 20, 19, 30, 0),
    end: new Date(2021, 10, 22, 9, 0, 0),
  },
];
export default events;
